import { useCallback, useEffect, useState } from 'react';

/** Alineado con Tailwind: `md` 768px, `lg` 1024px */
const QUERY_LG = '(min-width: 1024px)';
const QUERY_MD = '(min-width: 768px)';

const PAGE_SIZE_LG = 12;
const PAGE_SIZE_MD = 9;
const PAGE_SIZE_MOBILE = 4;

function readPageSize(): number {
  if (typeof window === 'undefined') return PAGE_SIZE_LG;
  if (window.matchMedia(QUERY_LG).matches) return PAGE_SIZE_LG;
  if (window.matchMedia(QUERY_MD).matches) return PAGE_SIZE_MD;
  return PAGE_SIZE_MOBILE;
}

/**
 * Tamaño de “página” local para material almacén: 12 (desktop grande), 9 (tablet / desktop pequeño), 4 (móvil).
 */
export function useResponsiveMaterialPageSize(): number {
  const [pageSize, setPageSize] = useState(() => readPageSize());

  const sync = useCallback(() => {
    setPageSize(readPageSize());
  }, []);

  useEffect(() => {
    sync();
    const mqlLg = window.matchMedia(QUERY_LG);
    const mqlMd = window.matchMedia(QUERY_MD);
    mqlLg.addEventListener('change', sync);
    mqlMd.addEventListener('change', sync);
    return () => {
      mqlLg.removeEventListener('change', sync);
      mqlMd.removeEventListener('change', sync);
    };
  }, [sync]);

  return pageSize;
}
